import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSpecial = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSpecial",
  viewBox: "0 0 20 20",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M6 3.75q1.34 0 2.03 1 .7 1 .7 2.8a5 5 0 0 1-.66 2.83q-.65 1.01-2.06 1.01-1.3 0-2-1.01a5 5 0 0 1-.68-2.82q0-1.8.64-2.81.64-1 2.04-1m.02 1.74q-.38 0-.55.52-.18.51-.18 1.56t.18 1.58.55.52.56-.52.19-1.58q0-1.05-.19-1.56-.17-.52-.56-.52m8.04-1.57L7.77 16.1H5.91L12.2 3.92zm-.1 4.7q1.32 0 2.02 1 .69 1 .69 2.8T16 15.23q-.65 1.02-2.06 1.02-1.3 0-2-1.02a5 5 0 0 1-.67-2.81q0-1.8.63-2.8.64-1 2.04-1m0 1.73q-.37 0-.55.52-.18.51-.18 1.57 0 1.05.18 1.57t.56.52.56-.51q.18-.53.18-1.58t-.18-1.57-.56-.52"
  })
}));
IconSpecial.displayName = 'IconSpecial';